var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonArrow = function SvgButtonArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    stroke: "var(--huma-color-foreground-constructive-bold)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 26.5001C18.8883 23.6941 27.3063 13.5224 28.7093 3.35059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3096 6.06885L28.8745 1.94332L33 7.50822"
  })));
};
export default SvgButtonArrow;